<!--
 * @Author: xiaokun
 * @Date: 2020-02-27 13:41:53
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-11 11:48:41
 * @Description: 话术库左侧树形控件
 -->

<template>
  <div class="common-tree-wrapper">
    <mk-tree
      ref="tree"
      :data="treeData"
      node-key="_id"
      :default-expanded-keys="defaultExpandedKeys"
      class="common-tree"
      @node-click="onNodeClick"
      @node-expand="onNodeExpand"
      @node-collapse="onNodeCollapse"
    >
      <template v-slot="{node,data}">
        <span class="menu-name">
          <span class="menu-name-content">
            <span class="menu-name-text">
              <ds-iconfont icon-class="icon-ds-wenjianjia"></ds-iconfont>
              <span>{{ data.label }}</span>
            </span>
            <!-- 展示新增红点 -->
            <div
              v-if="data.showTip === 'addFolder'"
              class="menu-name-new-icon"
            />
          </span>

          <span class="menu-operate">
            <mk-popover
              v-model="node.addMenuPop"
              placement="top-start"
              trigger="click"
              popper-class="question-bank-popover"
            >
              <div>
                <div class="pop-title">添加文件夹</div>
                <div class="pop-input">
                  <mk-input
                    v-model="addMenuName"
                    placeholder="请输入文件夹名称"
                    maxlength="10"
                    show-word-limit
                  />
                </div>
                <permission-settings
                  v-if="isAdminOrManage && node.addMenuPop"
                  :params="params"
                />
                <div class="pop-button">
                  <mk-button-biz
                    width="56px"
                    height="24px"
                    @click="node.addMenuPop = false"
                  >取消</mk-button-biz>
                  <mk-button-biz
                    type="primary"
                    width="56px"
                    height="24px"
                    @click="onAddMenu(data)"
                  >确定</mk-button-biz>
                </div>
              </div>
              <ds-iconfont
                v-if="data.level < 3"
                slot="reference"
                icon-class="icon-ds-tianjia1"
                @click.stop="showAddMenuPop(data)"
              ></ds-iconfont>
            </mk-popover>
            <mk-popover
              v-model="node.editMenuPop"
              placement="top-start"
              trigger="click"
              popper-class="question-bank-popover"
            >
              <div>
                <div class="pop-title">编辑文件夹</div>
                <div class="pop-input">
                  <mk-input
                    v-model="editMenuName"
                    placeholder="请输入文件夹名称"
                    maxlength="10"
                    show-word-limit
                  />
                </div>
                <permission-settings
                  v-if="isAdminOrManage && node.editMenuPop"
                  :params="params"
                />
                <div class="pop-button">
                  <mk-button-biz
                    width="56px"
                    height="24px"
                    @click="node.editMenuPop = false"
                  >取消</mk-button-biz>
                  <mk-button-biz
                    type="primary"
                    width="56px"
                    height="24px"
                    @click="onChangeMenuName(data)"
                  >确定</mk-button-biz>
                </div>
              </div>
              <ds-iconfont
                v-if="data.level > 0"
                slot="reference"
                icon-class="icon-ds-bianji"
                @click.stop="showEditMenuPop(data)"
              ></ds-iconfont>
            </mk-popover>
            <ds-iconfont
              v-if="data.level > 0"
              icon-class="icon-ds-shanchu"
              @click.native.stop="deleteMenu(data._id)"
            ></ds-iconfont>
          </span>
        </span>
      </template>
    </mk-tree>
    <mk-dialog-confirm
      :visible.sync="isShowConfirmDialog"
      title="确认要删除文件夹？"
      tip="删除该文件后，下属的子文件夹及问题都会被删除，不可恢复，是否确认操作？"
      append-to-body
      @on-confirm="onConfirm"
    />
  </div>
</template>

<script>
import PermissionSettings from '../permission-settings'
export default {
  name: 'CommonTree',
  components: {
    PermissionSettings
  },
  props: {
    // 菜单树用到的api
    apis: {
      type: Object,
      default: () => {
        return {
          get: '',
          patch: '',
          delete: '',
          post: ''
        }
      }
    }
  },
  data () {
    return {
      // tree data
      treeData: [],
      // 当前操作的menu的id
      targetId: null,
      // 是否展示删除确认框
      isShowConfirmDialog: false,
      // 新增menu input框的值
      addMenuName: '',
      // 编辑menu的input的值
      editMenuName: '',
      defaultExpandedKeys: [],
      treeVersion: 0,
      // 是否正在加载
      isLoading: false,
      // 是否显示权限管理
      isAdminOrManage: false,
      params: {
        // 是否能编辑可见范围
        canEdit: true,
        viewPart: false,
        dmList: {
          dept: [],
          member: []
        }
      },
      // 当前展示popover的node的key
      nodeKey: ''
    }
  },
  computed: {
    // 当前menu的版本
    version () {
      return this.treeData[0].version
    }
  },
  created () {
    this.getTreeData()
    this.jugeAdminOrManage()
  },
  methods: {
    // 获得tree数据
    async getTreeData () {
      this.isLoading = true
      let { data, success } = await this.apis.get()
      if (success) {
        // 默认展开二级菜单
        this.defaultExpandedKeys = [data._id]
        this.treeData = [data]
        this.$emit('tree-init', data)
      }
      this.isLoading = false
    },

    // 更新tree数据，主要是为了导入后 展示新增状态
    updateTreeData (data) {
      this.treeData = [data]
      this.$emit('tree-init', data)
    },

    // 当节点被点击时
    onNodeClick (data) {
      if (data.showTip === 'addFolder') {
        data.showTip = ''
      }
      this.$emit('node-click', data)
    },

    // 当节点被展开时候，加入到数组中，更新节点的时候重新渲染tree用于展开
    onNodeExpand ({ _id }) {
      this.defaultExpandedKeys.push(_id)
    },

    // 当节点被收起时候，从数组中移除，更新节点的时候重新渲染tree用于展开
    onNodeCollapse ({ _id }) {
      let index = this.defaultExpandedKeys.indexOf(_id)
      this.defaultExpandedKeys.splice(index, 1)
    },

    // 打开新增menu的pop
    showAddMenuPop (data) {
      this.closeOtherPopover(data, 'add')
      this.addMenuName = ''
      const { viewPart, deptInfo, userInfo } = data
      let member = []
      let dept = []
      deptInfo.forEach((item) => {
        dept.push({
          id: item._id,
          name: item.name
        })
      })
      userInfo.forEach((item) => {
        member.push({
          id: item._id,
          name: item.name
        })
      })
      this.params = {
        viewPart,
        canEdit: !viewPart,
        dmList: {
          dept,
          member
        }
      }
    },

    // 打开编辑menu名称的popover
    showEditMenuPop (data) {
      this.closeOtherPopover(data, 'edit')
      const { viewPart, label, deptInfo, userInfo, canEdit } = data
      this.editMenuName = label
      let member = []
      let dept = []
      deptInfo.forEach((item) => {
        dept.push({
          id: item._id,
          name: item.name
        })
      })
      userInfo.forEach((item) => {
        member.push({
          id: item._id,
          name: item.name
        })
      })
      this.params = {
        viewPart,
        canEdit,
        dmList: {
          dept,
          member
        }
      }
    },

    // 新增menu
    async onAddMenu ({ _id }) {
      let depts, users
      let viewPart = this.params.viewPart
      depts = this.params.dmList.dept.map((item) => item.id)
      users = this.params.dmList.member.map((item) => item.id)
      if (!this.addMenuName) {
        return this.$message.error('请输入文件夹名称')
      }
      if (depts.length === 0 && users.length === 0 && viewPart) {
        return this.$message.error('请选择员工/部门')
      }
      // 如果是查看全部，则清空数据
      if (!viewPart) {
        depts = []
        users = []
      }
      let params = {
        _id: this.uuid(),
        // true在首部新增
        head: false,
        label: this.addMenuName,
        parent: _id,
        version: this.version,
        viewPart: viewPart,
        depts,
        users
      }
      let res = await this.apis.post(params)
      if (res.success) {
        this.treeData = [res.data]
        this.$message.success('添加成功')
        this.$emit('update-data', res.data)
      } else if (res.code === 400403) {
        this.$message.error(res.msg)
      } else {
        this.$message.error('添加失败')
      }
    },

    // 修改文件夹名称
    async onChangeMenuName (data) {
      let depts, users
      let viewPart = this.params.viewPart
      depts = this.params.dmList.dept.map((item) => item.id)
      users = this.params.dmList.member.map((item) => item.id)
      if (!this.editMenuName) {
        return this.$message.error('请输入文件夹名称')
      }
      if (depts.length === 0 && users.length === 0 && viewPart) {
        return this.$message.error('请选择员工/部门')
      }
      // 如果是查看全部，则清空数据
      if (!viewPart) {
        depts = []
        users = []
      }
      let params = {
        _id: data._id,
        label: this.editMenuName,
        version: this.version,
        viewPart: viewPart,
        depts,
        users
      }
      let res = await this.apis.patch(params)
      if (res.success) {
        this.treeData = [res.data]
        this.$emit('on-modify-menu', res.data)
        this.$emit('update-data', res.data)
        this.$message.success('修改成功')
      } else if (res.code === 400403) {
        this.$message.error(res.msg)
      } else {
        this.$message.error('修改失败')
      }
    },

    // 删除文件夹
    deleteMenu (id) {
      this.targetId = id
      this.isShowConfirmDialog = true
    },

    // 确认删除文件夹
    async onConfirm () {
      let id = this.targetId
      let params = {
        _id: id,
        version: this.version
      }
      let res = await this.apis.delete(params)
      if (res.success) {
        this.isShowConfirmDialog = false
        this.treeData = [res.data]
        this.$emit('on-delete-menu', id)
        this.$emit('update-data', res.data)
        this.$message.success('删除成功')
      } else if (res.code === 400403) {
        this.$message.error(res.msg)
      } else {
        this.$message.error('删除失败')
      }
    },

    // 关闭其余popover
    closeOtherPopover (data, type) {
      // 非当前节点，关闭其他popover
      if (this.nodeKey && this.nodeKey !== data._id) {
        let node = this.$refs.tree.getNode(this.nodeKey)
        if (node.addMenuPop) {
          node.addMenuPop = false
        }
        if (node.editMenuPop) {
          node.editMenuPop = false
        }
      }
      // 当前节点，若点击新增，关闭编辑popover
      // 若为编辑，同理
      if (this.nodeKey && this.nodeKey === data._id) {
        let node = this.$refs.tree.getNode(this.nodeKey)
        if (type === 'add' && node.editMenuPop) {
          node.editMenuPop = false
        }
        if (type === 'edit' && node.addMenuPop) {
          node.addMenuPop = false
        }
      }
      this.nodeKey = data._id
    },

    // 判断是不是超级管理员和管理员
    // async jugeAdminOrManage () {
    //   const { success, data } = await ACCOUNTAPIS.RoleApi.v1RoleGetGet()
    //   if (success) {
    //     if (data.Type === 'manage' || data.Type === 'admin') {
    //       this.isAdminOrManage = true
    //     } else {
    //       this.isAdminOrManage = false
    //     }
    //   } else {
    //     this.isAdminOrManage = false
    //   }
    //   // const user = JSON.parse(window.localStorage.getItem('user'))
    //   // if (user && (user.identity === 'admin' || user.identity === 'manage')) {
    //   //   this.isAdminOrManage = true
    //   // } else {
    //   //   this.isAdminOrManage = false
    //   // }
    // }
    jugeAdminOrManage () {
      const pcFuncLimits = JSON.parse(localStorage.getItem('user')).roleLimits.pcFuncLimits
      let i = 0
      let len = pcFuncLimits.length
      let state = false
      for (i; i < len; i++) {
        if (pcFuncLimits[i] === 'func_contentSpeechManage') {
          state = true
          break
        }
      }
      this.isAdminOrManage = state
    }
  }
}
</script>

<style lang="scss" scoped>
.common-tree {
  padding: 10px 0;

  .menu-name {
    font-size: 13px;
    color: #595959;
    display: flex;
    justify-content: space-between;
    width: 100%;

    &:hover {
      .menu-operate {
        display: inline-block;
      }
    }

    .icon-ds-wenjianjia {
      color: rgba(0, 156, 255, 1);
      margin-right: 3px;
    }

    .menu-name-content {
      display: flex;

      .menu-name-text {
        max-width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .menu-name-new-icon {
        display: inline-block;
        margin-top: 8px;
        margin-left: 3px;
        width: 6px;
        height: 6px;
        background: #ff6b6b;
        border-radius: 50%;
      }
    }

    .menu-operate {
      display: none;

      .ds-iconfont {
        color: rgba(0, 156, 255, 1);
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }

  // 以下代码为覆盖tree样式
  /deep/ .el-tree-node__expand-icon {
    color: #595959;
  }

  /deep/ .el-tree-node__expand-icon.is-leaf {
    color: transparent;
  }

  // /deep/ .el-tree-node:focus > .el-tree-node__content

  /deep/ .el-tree-node__content {
    height: 32px;
    line-height: 32px;
    color: #595959;

    &:hover {
      background-color: #dbf1ff;
    }

    .el-tree-node__expand-icon {
      margin-left: 15px;
    }

    .menu-name {
      &:first-child {
        margin-left: 15px;
      }
    }
  }
}
</style>
